import { Link } from "react-router-dom";

function ButtonLink({
    children,
    disabled = defaultValues.disabled,
    buttonFunction = defaultValues.buttonFunction,
    redirect,
    buttonClass = defaultValues.buttonClass
}) {
    return (
      <Link to={redirect}>
          <button disabled={disabled} className={buttonClass} onClick={() => buttonFunction()}>
              {children}
          </button>
      </Link>
    )
}

const emptyFunction = () => {}

const defaultValues = {
    disabled: false,
    buttonFunction: emptyFunction,
    buttonClass: "button"
}

export default ButtonLink